import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideoOn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVideoOn"><Path d="M2.5 4.5H16.5V8.5L21.5 6.5V17.5L16.5 15.5V19.5H2.5V4.5Z" stroke="currentColor"/><Path d="M12.5 12C12.5 13.6569 11.1569 15 9.5 15C7.84315 15 6.5 13.6569 6.5 12C6.5 10.3431 7.84315 9 9.5 9C11.1569 9 12.5 10.3431 12.5 12Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconVideoOn;
